import React, { useState } from 'react';
import { format } from 'date-fns';

import Button from '../../library/button/button';
import Carousel, { Slide } from '../../library/carousel/carousel';
import Image from '../../library/image/image';
import Link from '../../library/link/link';
import Typography from '../../library/typography/typography';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { isArrayWithLength } from '../../shared/utils/validators/validators';

import { CmsPromotionCarouselItemComponent } from '../../shared/types/graphql-types';
import {
  PROMO_AMOUNT,
  PROMO_CODE,
  PROMO_CREATIVE,
  PROMO_NAME,
  PROMO_POSITION
} from '../../shared/constants/data-layer';

import './cms-promotion-carousel.scss';

interface CmsPromotionCarouselProps {
  cmsComponents: CmsPromotionCarouselItemComponent[];
}

function CmsPromotionCarousel(props: CmsPromotionCarouselProps) {
  const { cmsComponents } = props;

  const [slideIndex, setSlideIndex] = useState(0);

  function onSlideChange(slideIndex) {
    setSlideIndex(slideIndex);
  }

  function trackPromotion(promo, position) {
    const { image, code } = promo || {};
    const { url, altText } = image || {};
    const [amount] = altText?.match(/\$?\d+%?/) || [];

    trackAction('promotion_select', {
      [PROMO_AMOUNT]: amount,
      [PROMO_CODE]: code,
      [PROMO_CREATIVE]: url,
      [PROMO_NAME]: altText,
      [PROMO_POSITION]: position
    });
  }

  return (
    <div styleName="container">
      <div styleName="carousel-wrapper">
        {isArrayWithLength(cmsComponents) && (
          <Carousel
            onSlideChange={onSlideChange}
            showIndicators
            slideIndex={slideIndex}
          >
            {cmsComponents.map((promo, idx) => (
              <Slide key={`cfp-${idx}`} shouldLazyLoad styleName="slide">
                <Link
                  onClick={() => {
                    trackPromotion(promo, idx);
                  }}
                  styleName="promo-link"
                  to={promo.seeDetailsLink?.href || ''}
                >
                  <Image
                    alt={promo.image?.altText || `${promo.name} promo image`}
                    height="100"
                    src={promo.image?.url || ''}
                    width="300"
                  />
                </Link>

                <div styleName="carousel-content">
                  <Typography styleName="offer-description" weight="black">
                    {promo.name}
                    {promo.endDate && (
                      <span styleName="offer-expiration">
                        Expires {format(promo.endDate, 'MM/DD/YYYY')}
                      </span>
                    )}
                  </Typography>

                  <Button
                    href={
                      promo.seeProductsLink?.href
                        ? promo.seeProductsLink.href
                        : promo.seeDetailsLink?.href || ''
                    }
                    isPrimary
                    styleName="see-products-button"
                  >
                    {promo.seeProductsLink?.text
                      ? promo.seeProductsLink.text
                      : promo.seeDetailsLink?.text}
                  </Button>

                  {promo.seeProductsLink?.href && promo.seeDetailsLink?.href && (
                    <Button
                      href={promo.seeDetailsLink.href}
                      styleName="see-details-button"
                    >
                      {promo.seeDetailsLink.text}
                    </Button>
                  )}
                </div>
              </Slide>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  );
}

export default CmsPromotionCarousel;
